import { CommonConfig } from '@common';
import { Config } from '../../models/config.interface';

export const commonConfigFactory = (config: Config): CommonConfig => ({
  assetsPath: config.assetsPath,
  catalogueStore: config.catalogueStore,
  cookiePro: config.cookiePro,
  requestAction: config.requestAction,
  sessionInactivityDurationInMinutes: config.sessionInactivityDurationInMinutes,
  whiteLabelClient: config.whiteLabelClient,
});
